var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"valueWithCurrency"},[_c('div',{staticClass:"vwcCurrency"},[_vm._v(_vm._s(_vm.currencyValue))]),_c('div',{staticClass:"vwcPrice"},[_vm._v(_vm._s(_vm.priceValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }